module.exports = __webpack_public_path__ + "img/avatar4.48a5a9f1.png";